
import React, { useMemo } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Edit, Eye } from 'lucide-react';
import { Tutorial } from '@/types/tutorial';
import TutorialPreview from './TutorialPreview';
import TutorialEditorContent from './TutorialEditorContent';

interface TutorialCreatorTabsProps {
  tutorial: Partial<Tutorial>;
  editorContentProps: any;
}

const TutorialCreatorTabs: React.FC<TutorialCreatorTabsProps> = ({
  tutorial,
  editorContentProps
}) => {
  const previewTutorial = useMemo(() => tutorial, [tutorial]);

  return (
    <Tabs defaultValue="edit" className="w-full">
      <TabsList className="grid w-full max-w-md grid-cols-2 mb-6 h-12 p-1 bg-muted rounded-xl border border-border shadow-sm">
        <TabsTrigger 
          value="edit" 
          className="flex items-center gap-2 h-10 px-4 rounded-lg font-medium transition-all duration-200 
                   data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm data-[state=active]:border data-[state=active]:border-border
                   data-[state=inactive]:text-muted-foreground data-[state=inactive]:hover:text-foreground data-[state=inactive]:hover:bg-muted
                   focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          <Edit size={16} />
          <span className="hidden sm:inline">Editor</span>
        </TabsTrigger>
        <TabsTrigger 
          value="preview" 
          className="flex items-center gap-2 h-10 px-4 rounded-lg font-medium transition-all duration-200
                   data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm data-[state=active]:border data-[state=active]:border-border
                   data-[state=inactive]:text-muted-foreground data-[state=inactive]:hover:text-foreground data-[state=inactive]:hover:bg-muted
                   focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          <Eye size={16} />
          <span className="hidden sm:inline">Preview</span>
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="edit" className="w-full mt-0">
        <TutorialEditorContent {...editorContentProps} />
      </TabsContent>
      
      <TabsContent value="preview" className="w-full mt-0">
        <div className="w-full max-w-4xl mx-auto">
          <TutorialPreview tutorial={previewTutorial} />
        </div>
      </TabsContent>
    </Tabs>
  );
};

export default TutorialCreatorTabs;
